/* eslint-disable i18next/no-literal-string */
import { useSyncExternalStore } from "react";
import { DiagnosticsEmpty } from "@/features/diagnostics/components/lib/diagnostics-card.tsx";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import { formatShortDate } from "@/utils/formatters.ts";
import { EventLogTime } from "../lib/event-log-item.tsx";

export default function ProductReferenceList() {
    const calculations = useSyncExternalStore(
        DiagnosticsStore.subscribe,
        () => DiagnosticsStore.productReferenceCalculations,
    );

    if (calculations.length === 0) {
        return <DiagnosticsEmpty>No product reference calculations recorded yet!</DiagnosticsEmpty>;
    }

    return (
        <div className="product-reference-diagnostics">
            <ul className="product-reference-diagnostics__list">
                {calculations.map((entry) => (
                    <li
                        key={entry.id}
                        className={`product-reference-diagnostics__entry product-reference-diagnostics__entry--${entry.productFound ? "found" : "not-found"}`}
                    >
                        <div className="product-reference-diagnostics__header">
                            <EventLogTime>{formatShortDate(entry.timestamp)}</EventLogTime>
                            <span className="product-reference-diagnostics__source">{entry.source}</span>
                            <span className="product-reference-diagnostics__reference">{entry.reference}</span>
                            <span className="product-reference-diagnostics__status">
                                {entry.productFound ? "found" : "not found"}
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
